import React from "react";
import Layout from "@hoc/layouts/Layout";
import DetailsPageWithFiles from "@components/Pages/DetailsPageWithFiles";
import {useParams} from "react-router";
import useSingleModule from "../../../hooks/useSingleModule";

const ShowVacancyPage = () => {
  const {id} = useParams()
  const item = useSingleModule('vacancies', id)

  return (
    <Layout>
      <div className={'my-10 w-full lg:w-4/6 px-2 lg:px-0 mx-auto'}>
        <DetailsPageWithFiles item={item} />
      </div>
    </Layout>
  );
}

export default ShowVacancyPage;
